export enum Jurisdiction {
    DPDP = "DPDP",
    GDPR = "GDPR",
}

export enum ConfidenceLevel {
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW",
}

export enum Outcome {
    ANSWERED = "ANSWERED",
    ABSTAINED = "ABSTAINED",
    ERROR = "ERROR",
}

export interface QueryRequest {
    question: string;
    jurisdiction: Jurisdiction;
}

export interface RetrievalNode {
    id: string;
    text: string;
    score: number;
    metadata: Record<string, any>;
}

export interface AnswerResponse {
    query_id: string;
    answer: string;
    confidence: ConfidenceLevel;
    grounding_nodes: RetrievalNode[];
    faithfulness_score: number;
    outcome: Outcome.ANSWERED;
}

export interface AbstainResponse {
    query_id: string;
    reason: string;
    confidence: ConfidenceLevel.LOW;
    outcome: Outcome.ABSTAINED;
}

export type QueryResponse = AnswerResponse | AbstainResponse;
